module.exports = __webpack_public_path__ + "static/keytruda-lenvima-logo-2e09528233814da4e73a4896f3a36709.png";